import { motion } from "framer-motion";
import {
  Heart, Gift, Star, Wine, Users, Snowflake, Briefcase,
  Building2, Monitor, Music, Radio, Mic2, Film, Palette,
  Paintbrush, Calendar, Hammer, LayoutGrid,
} from "lucide-react";

const occasions = [
  { icon: Heart, label: "Hochzeit" },
  { icon: Gift, label: "Geburtstag" },
  { icon: Star, label: "Jubiläum" },
  { icon: Wine, label: "Polterabend" },
  { icon: Users, label: "Vereinsfeier" },
  { icon: Snowflake, label: "Weihnachtsfeier" },
  { icon: Briefcase, label: "Geschäftsfeier" },
  { icon: Building2, label: "Betriebsfest" },
  { icon: Monitor, label: "Produktpräsentation" },
  { icon: Music, label: "Konzert" },
  { icon: Radio, label: "Disco" },
  { icon: Mic2, label: "Theater" },
  { icon: Film, label: "Film & Foto" },
  { icon: Palette, label: "Ausstellung" },
  { icon: Paintbrush, label: "Kunstveranstaltung" },
  { icon: Calendar, label: "Tagung" },
  { icon: Hammer, label: "Workshop" },
  { icon: LayoutGrid, label: "Messe" },
];

export default function AnlassGrid() {
  return (
    <section className="py-24 md:py-32 bg-[#1C1C1E]" data-testid="anlass-grid">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <p
            className="text-[#C1440E] text-xs tracking-[0.4em] uppercase mb-4"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Alle Anlässe
          </p>
          <h2
            className="text-4xl md:text-5xl font-light text-[#F2EDE8] mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Was feiern Sie?
          </h2>
          <p
            className="text-[#A19D98] max-w-xl mx-auto text-sm"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Von der Hochzeit bis zur Filmproduktion – der Künstlerhof bietet den perfekten Rahmen.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {occasions.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              whileHover={{ scale: 1.04 }}
              className="flex flex-col items-center gap-3 p-4 bg-[#141414] border border-[#F2EDE8]/5 hover:border-[#C1440E] transition-all duration-250 cursor-default group"
              data-testid={`anlass-card-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <item.icon
                size={20}
                className="text-[#A19D98] group-hover:text-[#C1440E] transition-colors duration-200"
              />
              <span
                className="text-[#F2EDE8]/60 text-xs text-center leading-tight group-hover:text-[#F2EDE8] transition-colors duration-200"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {item.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
